import { Control, Controller, useController, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import React from 'react'
import { t } from 'ttag'
import { FormData } from '../../ChallengeAdmin'
import { CustomTypeCategory, customUnits } from '../../../../services/CustomTypes'
import { FormGroup, ListItem, ListItemIcon, ListItemText, Tooltip } from '@material-ui/core'
import YumFormSwitch from '../../../../components/YumFormSwitch/YumFormSwitch'

import { ReactComponent as SimpleManualEntryActiveIcon } from '../../../../assets/v3/icons/simple-manual-entry-active.svg'
import { ReactComponent as SimpleManualEntryInactiveIcon } from '../../../../assets/v3/icons/simple-manual-entry-inactive.svg'
import { isDistanceType } from '../../../../common/helpers/challenges'
import ChallengePointsAmountField from './ChallengePointsAmountField'
import { checkPointsError } from './ChallengePoints'
import YumField from '../../../../components/YumInput/YumInput'
import InputAdornment from '@material-ui/core/InputAdornment'
import { primaryBlue } from '../../../../styles/material-ui-theme-v2'
import YumBlueTooltip from '../../../../components/YumBlueTooltip/YumBlueTooltip'

interface ChallengePointsUnitFieldProps {
  setValue: UseFormSetValue<FormData>
  watch: UseFormWatch<FormData>
  name: any
  dailyGoalName: any
}

export default function ChallengePointsSimpleManualEntryField(props: ChallengePointsUnitFieldProps) {
  const { setValue, watch, name, dailyGoalName } = props

  const simpleManualEntry = watch(name)

  return (
    <>
      <FormGroup>
        <YumBlueTooltip
          title={t`One-click manual entry`}
          placement="top"
          enterTouchDelay={50}
          leaveTouchDelay={3000}
          arrow
          PopperProps={{
            container: document.getElementById('content'),
            disablePortal: true,
          }}
        >
          <ListItem
            style={{ height: '48px' }}
            role={undefined}
            dense
            button
            onClick={() => setValue(name, !simpleManualEntry)}
          >
            <ListItemIcon>
              {simpleManualEntry ? <SimpleManualEntryActiveIcon /> : <SimpleManualEntryInactiveIcon />}
            </ListItemIcon>
          </ListItem>
        </YumBlueTooltip>
      </FormGroup>
    </>
  )
}
